import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import MyTablesModal from '../Components/Modals/MyTablesModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'MyTables'>;

const MyTablesScreen: React.FC<Props> = ({ navigation }) => {
	return <MyTablesModal onClose={() => navigation.goBack()} />;
};

export default MyTablesScreen;
